import { useState, useEffect } from "react";

import api from "../../services/api";

const useMessages = ({ fromMe, dateStart, dateEnd }) => {
    const [loading, setLoading] = useState(true);
    const [count, setCount] = useState(0);

    useEffect(() => {
        setLoading(true);
        const delayDebounceFn = setTimeout(() => {
            const fetchMessages = async () => {
                try {
                    const { data } = await api.get("/messages-allMe", {
                        params: {
                            fromMe,
                            dateStart,
                            dateEnd,
                        },
                    });
                    // Suporta ambos os formatos de retorno
                    const messageCount = typeof data.count === 'number' 
                        ? data.count 
                        : (data.count?.[0]?.count || 0);
                    setCount(messageCount);
                    setLoading(false);
                } catch (err) {
                    setLoading(false);
                    setCount(0);
                    console.error("Erro ao buscar mensagens:", err);
                }
            };

            fetchMessages();
        }, 500);
        return () => clearTimeout(delayDebounceFn);
    }, [fromMe, dateStart, dateEnd]);

    return { count, loading };
};

export default useMessages;
